/**
 * Generador pseudoaleatorio con semilla (mulberry32).
 *
 * El juego NO debe usar `Math.random` en ninguna decision de partido. Con tick
 * fijo y aleatoriedad reproducible la simulacion entera es determinista, y eso
 * es lo que hace posibles tres cosas que valen mucho mas que el coste de esto:
 *
 *  - **Repeticiones**: basta con guardar semilla + inputs, no video.
 *  - **Online por lockstep**: cada cliente simula lo mismo y solo viajan inputs.
 *  - **Tests de IA reproducibles**: el mismo partido sale igual dos veces.
 */
export type Random = () => number;

export function createRandom(seed: number): Random {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = a;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

/** Aleatorio en [-1, 1). */
export function signed(random: Random): number {
  return random() * 2 - 1;
}
